<template>
  <div>
    <div class="setting">
      <div class="head-topbar lite-page-top linebottom sticky">
        <div class="topbar-left" @click="$router.go(-1)"><i class="icon-arrow-left"></i></div>
        <div class="topbar-main" v-if="type == 1"><h4>更换纪念馆背景图</h4></div>
        <div class="topbar-main" v-else><h4>更换墓园背景图</h4></div>
      </div>
      <div>
        <div class="memory_theme-list" v-if="type == 1">
          <span>
            <div class="theme-item">
              <div :class="hallInfo.hallBackground == 1 ? 'item-img theme-selected' : 'item-img'">
                <div class="adm-image">
                  <img
                    class="adm-image-img"
                    draggable="false"
                    style="object-fit: cover; display: block;"
                    src="../../../assets/jnt/jntbg/1/bg.png"
                  />
                </div>
              </div>
              <div class="item-title">祈福</div>
              <div v-if="hallInfo.hallBackground == 1" class="item-bottom">当前使用</div>
              <div v-else @click="jnt(1)" class="item-bottom">立即更换</div>
            </div>
            <div class="theme-item">
              <div :class="hallInfo.hallBackground == 2 ? 'item-img theme-selected' : 'item-img'">
                <div class="adm-image">
                  <img
                    class="adm-image-img"
                    draggable="false"
                    style="object-fit: cover; display: block;"
                    src="../../../assets/jnt/jntbg/2/bg.jpg"
                  />
                </div>
              </div>
              <div class="item-title">中元节</div>
              <div v-if="hallInfo.hallBackground == 2" class="item-bottom">当前使用</div>
              <div v-else @click="jnt('2')" class="item-bottom">立即更换</div>
            </div>
            <div class="theme-item">
              <div :class="hallInfo.hallBackground == 3 ? 'item-img theme-selected' : 'item-img'">
                <div class="adm-image">
                  <img
                    class="adm-image-img"
                    draggable="false"
                    style="object-fit: cover; display: block;"
                    src="../../../assets/jnt/jntbg/3/bg.jpg"
                  />
                </div>
              </div>
              <div class="item-title">秋叶黄</div>
              <div v-if="hallInfo.hallBackground == 3" class="item-bottom">当前使用</div>
              <div v-else @click="jnt(3)" class="item-bottom">立即更换</div>
            </div>
            <div class="theme-item">
              <div :class="hallInfo.hallBackground == 4 ? 'item-img theme-selected' : 'item-img'">
                <div class="adm-image">
                  <img
                    class="adm-image-img"
                    draggable="false"
                    style="object-fit: cover; display: block;"
                    src="../../../assets/jnt/jntbg/4/bg.jpg"
                  />
                </div>
              </div>
              <div class="item-title">端午节</div>
              <div v-if="hallInfo.hallBackground == 4" class="item-bottom">当前使用</div>
              <div v-else @click="jnt(4)" class="item-bottom">立即更换</div>
            </div>
            <div class="theme-item">
              <div :class="hallInfo.hallBackground == 5 ? 'item-img theme-selected' : 'item-img'">
                <div class="adm-image">
                  <img
                    class="adm-image-img"
                    draggable="false"
                    style="object-fit: cover; display: block;"
                    src="../../../assets/jnt/jntbg/5/bg.jpg"
                  />
                </div>
              </div>
              <div class="item-title">荷叶</div>
              <div v-if="hallInfo.hallBackground == 5" class="item-bottom">当前使用</div>
              <div v-else @click="jnt(5)" class="item-bottom">立即更换</div>
            </div>
            <div class="theme-item">
              <div :class="hallInfo.hallBackground == 6 ? 'item-img theme-selected' : 'item-img'">
                <div class="adm-image">
                  <img
                    class="adm-image-img"
                    draggable="false"
                    style="object-fit: cover; display: block;"
                    src="../../../assets/jnt/jntbg/6/bg.jpg"
                  />
                </div>
              </div>
              <div class="item-title">荷叶满江鲜</div>
              <div v-if="hallInfo.hallBackground == 6" class="item-bottom">当前使用</div>
              <div v-else @click="jnt(6)" class="item-bottom">立即更换</div>
            </div>
          </span>
        </div>
        <div class="memory_theme-list" v-else>
          <span>
            <div class="theme-item">
              <div
                :class="hallInfo.memBackground == 1 ? 'item-img theme-selected' : 'item-img'"
                style="height:21rem;"
              >
                <img
                  class="adm-image-img"
                  draggable="false"
                  style="object-fit: cover; display: block;"
                  src="../../../assets/jnt/muyuan/1.jpg"
                />
              </div>
              <div class="item-title">高山贵地</div>
              <div v-if="hallInfo.memBackground == 1" class="item-bottom">当前使用</div>
              <div v-else @click="muyuan(1)" class="item-bottom">立即更换</div>
            </div>
            <div class="theme-item">
              <div
                :class="hallInfo.memBackground == 2 ? 'item-img theme-selected' : 'item-img'"
                style="height:21rem;"
              >
                <img
                  class="adm-image-img"
                  draggable="false"
                  style="object-fit: cover; display: block;"
                  src="../../../assets/jnt/muyuan/2.jpg"
                />
              </div>
              <div class="item-title">落叶归根</div>
              <div v-if="hallInfo.memBackground == 2" class="item-bottom">当前使用</div>
              <div v-else @click="muyuan(2)" class="item-bottom">立即更换</div>
            </div>
            <div class="theme-item">
              <div
                :class="hallInfo.memBackground == 3 ? 'item-img theme-selected' : 'item-img'"
                style="height:21rem;"
              >
                <img
                  class="adm-image-img"
                  draggable="false"
                  style="object-fit: cover; display: block;"
                  src="../../../assets/jnt/muyuan/3.jpg"
                />
              </div>
              <div class="item-title">高山流水</div>
              <div v-if="hallInfo.memBackground == 3" class="item-bottom">当前使用</div>
              <div v-else @click="muyuan(3)" class="item-bottom">立即更换</div>
            </div>
            <div class="theme-item">
              <div
                :class="hallInfo.memBackground == 4 ? 'item-img theme-selected' : 'item-img'"
                style="height:21rem;"
              >
                <img
                  class="adm-image-img"
                  draggable="false"
                  style="object-fit: cover; display: block;"
                  src="../../../assets/jnt/muyuan/4.jpg"
                />
              </div>
              <div class="item-title">春色宜人</div>
              <div v-if="hallInfo.memBackground == 4" class="item-bottom">当前使用</div>
              <div v-else @click="muyuan(4)" class="item-bottom">立即更换</div>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'set',
  data() {
    return {
      show: false,
      type: '',
      id: '',
      // jntid: 1,
      // myid: 1,
      hallInfo: {
        id: null,
        memBackground: null,
        hallBackground: null,
      },
    }
  },
  methods: {
    jnt(id) {
      // this.jntid = id
      this.hallInfo.hallBackground = id
      this.updateHallBackground()
    },
    muyuan(id) {
      this.hallInfo.memBackground = id
      this.updateHallBackground()
    },
    goto(str) {
      this.$router.push({ path: str })
    },
    queryHallBackground() {
      var that = this
      this.$queryOne(
        'HallInfo',
        { id: this.id, myId: this.$store.getters.userId },
        this.hallInfo,
        function(res) {
          that.$fill(that.hallInfo, res.data)
        }
      )
    },
    updateHallBackground() {
      var that = this
      this.$update('HallInfo', this.hallInfo, function() {
        that.queryHallBackground()
      })
    },
  },
  mounted() {
    var params = this.$route.params
    this.type = params['type']
    this.id = params['id']
    this.queryHallBackground()
  },
  created() {
    var params = this.$route.params
    this.type = params['type']
    this.id = params['id']
  },
  watch: {},
}
</script>

<style>
.memory_theme-list {
  width: 100%;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 12px 1.363rem;
}

.memory_theme-list .theme-item {
  width: 46%;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2.272rem;
  position: relative;
  overflow: hidden;
}

.memory_theme-list .theme-item .item-preview {
  position: absolute;
  top: -66px;
  right: -66px;
  background: #e4803c;
  color: #fff;
  width: 108px;
  height: 108px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 15px;
  transform: rotate(45deg);
  z-index: 88;
  padding-bottom: 2px;
}

.memory_theme-list .theme-item .item-img {
  border-radius: 7.5px;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 13.636rem;
}

.memory_theme-list .theme-item .item-img img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  position: absolute;
  width: 100%;
  height: 100%;
  vertical-align: top;
  -o-object-fit: cover;
  object-fit: cover;
}

.memory_theme-list .theme-item:nth-child(2n-1) {
  margin-right: 7.5%;
}

.memory_theme-list .theme-item .item-title {
  font-size: 1.272rem;
  font-weight: 400;
  color: #333;
  font-family: PingFangSC-Regular, PingFang SC;
  margin: 1rem 0 7px;
}

.memory_theme-list .theme-item .item-bottom {
  width: 6.818rem;
  height: 2.181rem;
  line-height: 2.181rem;
  border: 1px solid #e4803c;
  border-radius: 1.09rem;
  text-align: center;
  font-size: 1.09rem;
  color: #e4803c;
}

.memory_theme-list .theme-item .item-bot {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 8px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.memory_theme-list .theme-item .item-bot .txt {
  font-size: 1.1rem;
  color: #333;
}

.memory_theme-list .theme-item .item-img .item-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.memory_theme-list .theme-item .item-img .item-mask .mask-icon {
  width: 1.82rem;
  height: 2.18rem;
  margin-bottom: 7px;
  position: static;
}

.memory_theme-list .theme-item .item-img .item-mask .mask-text {
  font-size: 1.18rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  display: block;
}

.memory_theme-list .theme-item .item-img .item-mask .mask-btn {
  width: 5rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  background-color: #e4803c;
  border-radius: 20px;
  color: #fff;
  font-size: 1.09rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 1rem;
}

.memory_theme-list .theme-item .item-img .remain-time {
  width: 6.36rem;
  height: 2.18rem;
  line-height: 2.18rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0 7.5px 0 7.5px;
  text-align: center;
  color: #fff;
  font-size: 1rem;
  position: absolute;
  top: 0;
  right: 0;
}

.navbar .adm-tabs-tab {
  color: #666;
}

.navbar .adm-tabs-tab-active {
  color: #333;
}

.memory_theme-list .theme-item .item-bot .original-price {
  background: linear-gradient(156deg, #f68d31, #f4531e);
  border-radius: 20px;
  padding: 4px 8px;
  color: #fff;
  display: inline-block;
}

.memory_theme-list .theme-item .item-bot .original-price .amount {
  font-size: 1.3rem;
  line-height: 18px;
  margin-left: 1px;
}

.memory_theme-list .theme-item .item-bot .original-price .txt1 {
  font-size: 1.1rem;
  line-height: 18px;
  position: relative;
  top: 0;
  margin-left: 1px;
}

.memory_theme-list .theme-selected {
  border: 3px solid #e4803c;
  box-sizing: border-box;
  border-radius: 7.5px;
}

.memory_theme-list .theme-item .item-lock {
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.memory_theme-list .theme-item .item-lock .icon-lock {
  width: 20px;
  height: 20px;
}

.memory_theme-list .theme-item .item-lock .txt {
  margin-top: 9px;
  color: #fff;
  font-size: 1rem;
}
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/left1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.settingPage .content {
  color: rgb(177, 109, 78);
  position: relative;
  padding: 0;
  text-align: center;
  font-size: 1.3rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 4.2rem;
  display: flex;
}
</style>
